import AdditionalDetails from 'views/CandidateApp/CandidateForm/Sections/AdditionalDetails/AdditionalDetails';
import Address from 'views/CandidateApp/CandidateForm/Sections/Address/Address';
import Consents from 'views/CandidateApp/CandidateForm/Sections/Consents/Consents';
import FCRA from 'views/CandidateApp/CandidateForm/Sections/FCRA/FCRA';
import PersonalDetails from 'views/CandidateApp/CandidateForm/Sections/PersonalDetails/PersonalDetails';
import VerifyIdentity from 'views/CandidateApp/CandidateForm/Sections/VerifyIdentity/VerifyIdentity';

export const SECTION_COMPONENTS = {
  personal_details: PersonalDetails,
  address: Address,
  verify_identity: VerifyIdentity,
  additional_details: AdditionalDetails,
  fcra: FCRA,
  consents: Consents,
};
